import { Outlet } from "react-router-dom"
const MainContacts = () =>{

    return(
        <div className=" w-full h-full">
         <Outlet/>
        </div>
    )
}


export default MainContacts;